{
 "helper": {
  "x": 170,
  "y": 900,
  "w": 601,
  "h": 31,
  "lane": {
   "x": 160,
   "y": 892,
   "w": 620,
   "h": 44
  }
 },
 "c1": {
  "x": 134,
  "y": 995,
  "w": 37,
  "h": 57,
  "lane": {
   "x": 110,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "c2": {
  "x": 254,
  "y": 995,
  "w": 51,
  "h": 57,
  "lane": {
   "x": 236,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "c3": {
  "x": 383,
  "y": 995,
  "w": 46,
  "h": 58,
  "lane": {
   "x": 362,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "c4": {
  "x": 531,
  "y": 991,
  "w": 6,
  "h": 66,
  "lane": {
   "x": 488,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "c5": {
  "x": 636,
  "y": 1060,
  "w": 53,
  "h": 5,
  "lane": {
   "x": 614,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "c6": {
  "x": 764,
  "y": 1060,
  "w": 53,
  "h": 5,
  "lane": {
   "x": 740,
   "y": 970,
   "w": 100,
   "h": 96
  }
 },
 "join.label": {
  "x": 303,
  "y": 1152,
  "w": 246,
  "h": 98,
  "lane": {
   "x": 240,
   "y": 1150,
   "w": 460,
   "h": 100
  }
 },
 "scan.label": {
  "x": 358,
  "y": 1346,
  "w": 344,
  "h": 38,
  "lane": {
   "x": 330,
   "y": 1336,
   "w": 430,
   "h": 56
  }
 },
 "footer": {
  "x": 312,
  "y": 1452,
  "w": 320,
  "h": 28,
  "lane": {
   "x": 280,
   "y": 1446,
   "w": 380,
   "h": 44
  }
 }
}